<mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group">
  <mat-card class="ml-kpi-option-card mat-elevation-z0" *ngFor="let option of chooseOptions">
    <mat-radio-button
      class="ml-kpi-radio-button"
      color="primary"
      [value]="option"
      [checked]="chosenKpiOption?.id === option.id"
      (click)="onOptionClick(option)"
    >
      <div>{{ option.description }}</div>
      <div class="ml-option-subtitle" *ngIf="option.subtitle">{{ option.subtitle }}</div>
    </mat-radio-button>

    <ng-container *ngIf="option.expandable && option.expandable.value">
      <mat-table class="ml-custom-kpi-table" [dataSource]="kpiData">
        <ng-container matColumnDef="name">
          <td class="ml-custom-kpi-table-col" mat-cell *matCellDef="let element">
            <i
              class="ml-custom-kpi-check-icon ml-custom-kpi-check-icon-disabled material-icons"
              [ngClass]="
                selectCustomKpiOnClick(element)
                  ? 'ml-custom-kpi-check-icon-selected'
                  : 'ml-custom-kpi-check-icon-disabled'
              "
              >check_circle_outline</i
            >
            <span>{{ element.value.friendlyname }}</span>
          </td>
        </ng-container>
        <tr
          mat-row
          class="ml-custom-kpi-table-row ml-custom-kpi-table-row-content"
          *matRowDef="let row; columns: displayedColumns"
          (click)="onRowClick(row)"
        ></tr>
      </mat-table>
    </ng-container>
  </mat-card>
  <div [style.display]="!paginatorStatus ? 'block' : 'none'">
    <nrwl-paginator
      #paginator
      [totalResult]="numberOfKPI"
      [hidePageSizer]="true"
      (nextPage)="nextPage($event)"
    ></nrwl-paginator>
  </div>
</mat-radio-group>
